import { Injectable } from '@angular/core';
import { CreateRoleApplicationConfiguration } from '@app/domain/role_application_configuration/model/create-role-application-configuration.model';
import { RoleApplicationConfiguration } from '@app/domain/role_application_configuration/model/role-application-configuration.model';
import { RoleApplicationConfigurationAPIService } from '@app/domain/role_application_configuration/api/role-application-configuration-api.service';
import { NotifyUtils } from '@app/shared/utils/notify.utils';
import { Observable, firstValueFrom } from 'rxjs';
import { Page } from '@app/models/api/page.model';
import { PagingParams } from '@app/models/api/paging-params.model';
import { SortingParams } from '@app/models/api/sorting-params.model';
import { RoleApplicationMessages } from '@app/domain/role_application/locale/role-application.messages';
import { InFlightRegistry } from '@app/shared/utils/in-flight-registry';

@Injectable({
  providedIn: 'root'
})
export class RoleApplicationConfigurationBusinessService {

  // key -> the write currently in flight for that configuration. A duplicate call while one is in
  // flight is coalesced onto the same promise (see InFlightRegistry) rather than rejected.
  private static _updating: InFlightRegistry;

  constructor(
    private roleApplicationConfigurationAPI: RoleApplicationConfigurationAPIService,
    private notifyUtils: NotifyUtils
  ) {
    RoleApplicationConfigurationBusinessService._updating = new InFlightRegistry();
  }

  get(
    ids: number[]
  ): Observable<RoleApplicationConfiguration[]> {
    return this.roleApplicationConfigurationAPI
      .get(ids);
  }

  getPaginated(
    pagingParams: PagingParams,
    sortingParams: SortingParams,
    ids: number[]
  ): Observable<Page<RoleApplicationConfiguration>> {
    return this.roleApplicationConfigurationAPI.getPaginated(pagingParams, sortingParams, ids);
  }

  create(createDto: CreateRoleApplicationConfiguration): Promise<RoleApplicationConfiguration> {
    console.log(createDto);
    return firstValueFrom(this.roleApplicationConfigurationAPI.create(createDto))
      .then(res => {
        this.notifyUtils.notify(RoleApplicationMessages.SUCCESS_CREATE_CONFIGURATION);
        return res;
      });
  }

  update(id: number, updateDto: CreateRoleApplicationConfiguration): Promise<RoleApplicationConfiguration> {
    return RoleApplicationConfigurationBusinessService._updating.run(id, () =>
      firstValueFrom(this.roleApplicationConfigurationAPI.update(id, updateDto))
        .then(res => {
          this.notifyUtils.notify(RoleApplicationMessages.SUCCESS_UPDATE);
          return res;
        })
    );
  }

  delete(id: number): Promise<RoleApplicationConfiguration> {
    return RoleApplicationConfigurationBusinessService._updating.run(id, () =>
      firstValueFrom(this.roleApplicationConfigurationAPI.delete(id))
        .then(res => {
          this.notifyUtils.notify(RoleApplicationMessages.SUCCESS_DELETE);
          return res;
        })
    );
  }

  getApplicableConfigurationForRole(roleId: number): Observable<RoleApplicationConfiguration> {
    return this.roleApplicationConfigurationAPI.getApplicableConfigurationForRole(roleId);
  }
}
